import { Injectable, inject } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { LiveCasinoCategoryModel } from '@frontend/sports/types/components/live-casino';

import { LiveCasinoGameTrackingModel, LiveCasinoTrackingConstants } from './cross-sell-data.model';

@Injectable({
    providedIn: 'root',
})
export class CrossSellTrackingService {
    private trackingService = inject(TrackingService);

    trackLiveCasinoGameLaunch(gameModel: LiveCasinoGameTrackingModel) {
        this.trackingService.track(trackingConstants.EVENT_GAME_OPEN, {
            [trackingConstants.COMPONENT_GAME_NAME]: gameModel.gameName,
            [trackingConstants.COMPONENT_GAME_TYPE]: gameModel.gameType,
            [trackingConstants.COMPONENT_GAME_POSITION]: gameModel.gamePosition,
            [trackingConstants.COMPONENT_GAME_SECTION]: gameModel.gameSubCategoryType || gameModel.gameCategoryType,
            [trackingConstants.COMPONENT_GAME_GRID_POSITION]: gameModel.gridPosition,
            [trackingConstants.COMPONENT_GAME_CONTAINER_LOCATION]: LiveCasinoTrackingConstants.Game_Container_Location,
            [trackingConstants.COMPONENT_GAME_DISPLAY_NAME]: gameModel.gameDisplayName,
            [trackingConstants.COMPONENT_CATEGORY_TYPE]: LiveCasinoTrackingConstants.Game_Category_Type,
            [trackingConstants.COMPONENT_CATEGORY_SUB_TYPE]: LiveCasinoTrackingConstants.Game_Category_Sub_Type,
        });
    }

    trackGameImpressions(categories: LiveCasinoCategoryModel[]) {
        const gameImpressions: any[] = [];
        categories.forEach((category, catIndex) => {
            category.games.forEach((game, gameIndex) => {
                gameImpressions.push({
                    [trackingConstants.COMPONENT_GAME_GRID_POSITION]: `${catIndex}:${gameIndex}`,
                    [trackingConstants.COMPONENT_GAME_POSITION]: gameIndex,
                    [trackingConstants.COMPONENT_GAME_SECTION]: category.subCategoryName || category.name,
                    [trackingConstants.COMPONENT_CATEGORY_SUB_TYPE]: LiveCasinoTrackingConstants.Game_Category_Sub_Type,
                    [trackingConstants.COMPONENT_GAME_DISPLAY_NAME]: game.title,
                    [trackingConstants.COMPONENT_GAME_ID]: `${category.id}${category.subCategoryName}_${game.id}`,
                    [trackingConstants.COMPONENT_GAME_NAME]: game.id,
                    [trackingConstants.COMPONENT_GAME_TYPE]: game.provider,
                    [trackingConstants.GAME_LIST]: LiveCasinoTrackingConstants.Game_List,
                });
            });
        });

        this.trackingService.track(trackingConstants.EVENT_GAME_IMPRESSIONS, { [trackingConstants.GAME_IMPRESSIONS]: gameImpressions });
    }
}
